var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDI4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202.08,
    height: 227,
    viewBox: "0 0 202.08 227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135349",
    "data-name": "Group 135349",
    transform: "translate(-18018.391 -3026.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6011",
    "data-name": "Rectangle 6011",
    d: "M20.221-.75H180.359A21,21,0,0,1,201.33,20.221V205.279a21,21,0,0,1-20.971,20.971H20.221A21,21,0,0,1-.75,205.279V20.221A21,21,0,0,1,20.221-.75ZM180.359,215.381a10.113,10.113,0,0,0,10.1-10.1V20.221a10.113,10.113,0,0,0-10.1-10.1H20.221a10.113,10.113,0,0,0-10.1,10.1V205.279a10.113,10.113,0,0,0,10.1,10.1Z",
    transform: "translate(18019.141 3027.462)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91151",
    "data-name": "Path 91151",
    d: "M153.948,87.991c18.855,24.42,49.116,27.514,60.884,27.739-.167,15.413-5.043,68.464-61.732,99.145-59.471-31.768-61.5-83.486-60.761-98.334,11.536-.333,42.29-3.652,61.609-28.551m0-10.87a10.848,10.848,0,0,0-8.587,4.21c-16.341,21.058-42.739,24.036-53.333,24.341A10.876,10.876,0,0,0,81.484,116c-.826,16.667,1.515,73.754,66.493,108.464a10.853,10.853,0,0,0,10.29-.029c61.841-33.464,67.247-91.573,67.435-108.587a10.874,10.874,0,0,0-10.659-10.986c-10.478-.2-36.58-2.9-52.493-23.514a10.872,10.872,0,0,0-8.587-4.225Z",
    transform: "translate(17965.895 2988.785)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91152",
    "data-name": "Path 91152",
    d: "M112.08,136.262,88.506,112.688A5.435,5.435,0,0,1,96.192,105l15.889,15.889,34.766-34.759a5.435,5.435,0,1,1,7.685,7.687Z",
    transform: "translate(18000.484 3035.128)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDI4);
export default __webpack_public_path__ + "static/media/d-i-4.88c2480cae096cc26d99bb9c929c30be.svg";
export { ForwardRef as ReactComponent };